import React from 'react';
import { SessionsPricingAssets, SessionsPricing } from '@landr/pricing';
import { PricingTabDocument } from '../types';

export interface SessionsPricingTabProps {
    tab: PricingTabDocument;
    languageCode: string;
}

export const SessionsPricingTab: React.FC<SessionsPricingTabProps> = () => {
    return (
        <>
            <SessionsPricing />
            <SessionsPricingAssets />
        </>
    );
};
